import React from "react";
import AppConfig from "../../../../../Utility/Method/AppConfig";
import Info from "./components/Info";
import ClassInfo from "./components/ClassInfo";
import ClassStatus from "./components/ClassStatus";
import Actions from "./components/Actions";
import TimeInfo from "./components/TimeInfo";
import styled from "styled-components";
import { devices } from "../../../../../Utility/Devices";

import "../../DashboardListItem.scss";

const Card = styled.div`
  background: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
  border-radius: 10px;
  padding: 10px 15px;
  flex-wrap: wrap;
  @media ${devices.mobileL} {
    font-size: 0.7rem;
  }
  @media ${devices.laptop} {
    .break-1 {
      order: 4;
      border-top: 1px solid #cccccc;
      margin: 10px 0;
      flex-basis: 100%;
      height: 0;
    }
  }
  @media ${devices.tablet} {
    .break-2 {
      order: 2;
      border-top: 1px solid #cccccc;
      margin: 10px 0;
      flex-basis: 100%;
      height: 0;
    }
  }
  ::before {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 5px;
    height: 100%;
    background-color: ${({ color }) => color};
  }
`;

const Item = ({ hook, theme, data, lang, role, loading }) => {
  const classPosition = `جلسه ${data.SessionNumber} از ${data.PackageCount}`;

  return (
    <Card color={AppConfig.SessionStatus(data.Session.Status, theme).color}>
      <Info data={data} hook={hook} />
      <div className="break-2"></div>
      <ClassInfo loading={loading} data={data} classPosition={classPosition} />
      <div className="break-1"></div>
      <ClassStatus
        color={AppConfig.SessionStatus(data.Session.Status, theme).color}
        state={
          AppConfig.SessionStatus(data.Session.Status, theme).name[`${lang}`]
        }
        show={data.Session.Status === 4}
      />
      <TimeInfo
        loading={loading}
        data={data}
        theme={theme}
        role={role}
        hook={hook}
        lang={lang}
      />
      <Actions
        loading={loading}
        data={data}
        theme={theme}
        role={role}
        hook={hook}
        lang={lang}
      />
    </Card>
  );
};

export default Item;
